import type { CartUserModel } from '~/graphql/types/graphql'

export function getItemsForMiniCart(cartData: CartUserModel) {
    const { PRODUCT_PAGE_PREFIX, CURRENCY_SYMBOL_ZL } = useAppConfig()
    const { siteUrl } = useRuntimeConfig().public
    const { $i18n } = useNuxtApp()

    if (!cartData?.cart) {
        throw createError({
            statusMessage: `getItemsForMiniCart Error: cartData.cart not exist or Could not find a cart with ID`,
        })
    }

    const cartItems = cartData.cart.items.map(
        ({ product: { priceRange, name, url, thumbnail, id: productId }, quantity, id }) => {
            const { inPromotion, finalPrice, regularPrice } = usePrice(priceRange.minimumPrice)

            const normalizedFinalPrice = finalPrice.toFixed(2).toString().replace('.', ',')
            const normalizedRegularPrice = regularPrice.toFixed(2).toString().replace('.', ',')

            const product_price = inPromotion
                ? `<span class="price-including-tax" data-label="${$i18n.t('Bbk.product.price.withTax')}">
                    <span class="minicart-price special-price">
                        <span class="price">${normalizedFinalPrice}&nbsp;<span class="currency">${CURRENCY_SYMBOL_ZL}</span></span></span>
                                <span class="old-price">
                            <span class="cart-price">
                                <span class="price">${normalizedRegularPrice}&nbsp;<span class="currency">${CURRENCY_SYMBOL_ZL}</span></span></span>
                        </span>
                </span>`
                : `<span class="price-including-tax" data-label="${$i18n.t('Bbk.product.price.withTax')}">
                  <span class="minicart-price">
                      <span class="price">${normalizedFinalPrice}&nbsp;<span class="currency">${CURRENCY_SYMBOL_ZL}</span></span>
                  </span>
                </span>`

            return {
                product_name: name,
                product_url: `${siteUrl}/${PRODUCT_PAGE_PREFIX}/${url}`,
                product_image: {
                    src: thumbnail?.src || '',
                    alt: thumbnail?.alt || '',
                },
                product_price,
                item_id: id,
                qty: quantity,
                product_id: productId.toString(),
            }
        },
    )

    const subtotal = `<span class="price">${cartData.cart.totalPrices.total
        .toFixed(2)
        .toString()
        .replace('.', ',')} <span class="currency">${CURRENCY_SYMBOL_ZL}</span></span>`

    return {
        cartItems,
        subtotal,
    }
}
